export enum PaymentProvider {
  NONE = 'None',
  STRIPE = 'Stripe',
  MONEXT = 'Monext',
}
